import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'rt-product-logo',
  standalone: true,
  templateUrl: './product-logo.component.html',
  styleUrls: ['./product-logo.component.scss']
})
export class ProductLogoComponent {
  @Input() width: number | string = 95;
  @Input() height: number | string = 40;
  @Input() origin?: string;

  @HostBinding('class.logo-theme-white') get isWebsiteTheme() {
    return this.origin === 'website';
  }
}

